export const throttle = (func, timeFrame) => {
    let lastTime = 0;

    return function (...args) {
        const now = new Date();
        if (now - lastTime >= timeFrame) {
            func(...args);
            lastTime = now;
        }
    };
};

export const isEmpty = obj => Object.keys(obj).length === 0;

export const times = (n, func = i => i) => Array.from({ length: n }).map((_, i) => func(i));

export const debounce = (func, delay) => {
    let debounceTimer;

    return function (...args) {
        clearTimeout(debounceTimer);
        debounceTimer = setTimeout(() => func(...args), delay);
    };
};

export const range = (start, end, step = 1) => {
    const length = Math.floor((end - start) / step);

    return Array.from({ length }, (_, i) => start + i * step);
};

export const remove = (array, predicate) => {
    const index = array.findIndex(predicate);
    if (index >= 0) {
        return array.splice(index, 1);
    }

    return array;
};

export const forOwn = (object, iteratee) => {
    Object.keys(object).forEach(key => {
        iteratee(object[key], key, object);
    });
};

export const chunk = (array, size) => {
    return array.reduce((chunks, item, index) => {
        if (index % size === 0) {
            chunks.push([item]);
        } else {
            chunks[chunks.length - 1].push(item);
        }

        return chunks;
    }, []);
};

export const getValue = (object, keys) => {
    if (Array.isArray(keys) && keys.length > 0) {
        let result = object;
        for (const key of keys) {
            if (result && typeof result === 'object' && key in result) {
                result = result[key];
            } else {
                return undefined;
            }
        }

        return result;
    }
    if (typeof keys === 'string') {
        return object[keys];
    }

    return undefined;
};
